import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newContainer =
      event.detail.data.html.querySelector('product-price [ref="priceContainer"]');

    const currentContainer =
      this.querySelector('[ref="priceContainer"]');

    if (!newContainer || !currentContainer) return;

    const newPrice = newContainer.querySelector('.price');
    const newCompare = newContainer.querySelector('.compare-at-price');

    const currentPrice = currentContainer.querySelector('.price');
    let currentCompare = currentContainer.querySelector('.compare-at-price');

    // atualiza preço principal
    if (newPrice && currentPrice) {
      currentPrice.innerHTML = newPrice.innerHTML;
    }

    // atualiza / cria preço riscado
    if (newCompare) {
      if (!currentCompare) {
        currentCompare = newCompare.cloneNode(true);
        currentContainer.prepend(currentCompare);
      } else {
        currentCompare.innerHTML = newCompare.innerHTML;
      }
    } else if (currentCompare) {
      currentCompare.remove();
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
